module.exports = __webpack_public_path__ + "static/app-stores-logos-8c26d22413b9c3d9ff2e3e4ffebb42f3.png";